import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../analytics/Analytics.ts';
import { selectInternalVideoAdToShow } from './InternalVideoAdConfig.ts';
import { SocketMatchmakingSend } from '../socket/SocketMatchmakingSend.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { setElementOnClick } from '../ui_utils/DomUtils.ts';
import { uiManagerEvents } from '../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
const STORE_MEMBERSHIP_URL = '/store#membership';
export class UIInternalVideoAdController {
    static async start(matchType, onComplete) {
        const ad = selectInternalVideoAdToShow(matchType);
        if (ad == undefined) {
            if (onComplete != undefined) onComplete();
            else if (SocketMatchmakingSend.lastMatchmakingRequest) SocketMatchmakingSend.enterMatchmaker(SocketMatchmakingSend.lastMatchmakingRequest, false);
            return;
        }
        const imageUrl = await ad.loadImage();
        UIInternalVideoAdController.startGifAd(ad, imageUrl, onComplete);
    }
    static startGifAd(ad, imageUrl, onComplete) {
        const overlayDiv = UIInternalVideoAdController.createOverlay();
        const image = UIInternalVideoAdController.createImage(imageUrl);
        overlayDiv.appendChild(image);
        document.body.appendChild(overlayDiv);
        let resolved = false;
        let completeTimeout;
        const clearTimers = ()=>{
            clearTimeout(completeTimeout);
            completeTimeout = undefined;
        };
        const complete = (failReason)=>{
            if (resolved) return;
            resolved = true;
            clearTimers();
            if (failReason != undefined) trackInternalVideoAdFailed(failReason);
            else trackInternalVideoAdCompleted();
            overlayDiv.remove();
            if (onComplete != undefined) onComplete();
            else if (SocketMatchmakingSend.lastMatchmakingRequest) SocketMatchmakingSend.enterMatchmaker(SocketMatchmakingSend.lastMatchmakingRequest, false);
        };
        setElementOnClick(overlayDiv, ()=>{
            if (resolved) return;
            resolved = true;
            clearTimers();
            trackInternalVideoAdStoreClicked();
            uiManagerEvents.cancelMatchmakingSearch();
            if (isSubscriptionOverlayVariant()) {
                overlayDiv.remove();
                uiManagerEvents.premiumMembershipCheckAction();
            } else {
                if (!UIUtilsEjsVariables.isUserOnMobileAppOrWeb) overlayDiv.remove();
                navigateToPage(STORE_MEMBERSHIP_URL);
            }
        });
        image.addEventListener('error', ()=>complete('image_error'));
        trackInternalVideoAdStarted();
        completeTimeout = setTimeout(()=>complete(), ad.durationMs);
    }
    static createOverlay() {
        const overlayDiv = document.createElement('div');
        overlayDiv.classList.add('internal-video-ad-overlay');
        return overlayDiv;
    }
    static createImage(imageUrl) {
        const image = document.createElement('img');
        image.alt = '';
        image.src = imageUrl;
        image.classList.add('internal-video-ad-image');
        return image;
    }
}
function trackInternalVideoAdStarted() {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.InternalVideoAdStarted,
        category: AnalyticEventCategory.AdsPerformance
    });
}
function trackInternalVideoAdCompleted() {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.InternalVideoAdCompleted,
        category: AnalyticEventCategory.AdsPerformance
    });
}
function trackInternalVideoAdFailed(reason) {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.InternalVideoAdFailed,
        category: AnalyticEventCategory.AdsPerformance,
        stringValue: reason
    });
}
function trackInternalVideoAdStoreClicked() {
    void CA.sendAnalyticEvent({
        type: AnalyticEventType.InternalVideoAdStoreClicked,
        category: AnalyticEventCategory.AdsPerformance
    });
}
